import { Component, OnInit, Input } from '@angular/core';
import { TeaserItem } from 'app/interfaces/teaser-item.model';
import { ActivatedRoute } from '@angular/router';
import { Detail } from "app/interfaces/detail.model";

@Component({
  selector: 'app-teaser-block',
  templateUrl: './teaser-block.component.html',
  styleUrls: ['./teaser-block.component.scss']
})
export class TeaserBlockComponent implements OnInit {
  @Input() teaserItem: TeaserItem;
  @Input() subItems: Detail[];
  viewMode: string;

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    const parent = this.route.snapshot.parent;
    if (parent.url.length > 0) {
      this.viewMode = parent.url[0].path;
    }
  }

}
